import databaseLayers from './databaselayers'
import giscube from './giscube'

export default {
  databaseLayers,
  giscube
}
